import { dataTagSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTagSolid = /*#__PURE__*/createIcon(dataTagSolid)
export default IconTagSolid
